/**
 * RADIO-OPTION
 * Row of a list of choices : radio button, title and hint (built on list-item and radio-btn)
 */
import ListItem from "./list-item"
import RadioBtn from "./radio-btn"

interface OwnProps {
  hint?: string //Detail under the title
  indent?: boolean //Sub-choice
  isSelected: boolean
  onClick: Function
  title: string
}

function RadioOption(props: OwnProps) {
  return (
    <ListItem isEditable isSmall onClick={() => props.onClick()}>
      <div className="py-1" style={{ marginLeft: props.indent ? 28 : 0 }}>
        <RadioBtn active={props.isSelected} text={props.title} onClick={() => props.onClick()} />
        {props.hint && (
          <div className="grey-t text-sm" style={{ marginLeft: 28 }}>
            {props.hint}
          </div>
        )}
      </div>
    </ListItem>
  )
}

export default RadioOption
